import { useLayoutEffect } from 'react';
import { syncViewportHeightNow } from '../methods/viewportSheet.js';

/** Re-measure sheet viewport after mount (swipeable library + full-viewport sheet). */
const useViewportSheetDomSync = (isActive) => {
    useLayoutEffect(() => {
        if (!isActive) {
            return;
        }
        syncViewportHeightNow();
        const frameId = requestAnimationFrame(syncViewportHeightNow);
        return () => cancelAnimationFrame(frameId);
    }, [isActive]);
};

export { useViewportSheetDomSync };
//# sourceMappingURL=useViewportSheetDomSync.js.map
